<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>名稱</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.GroupID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.GroupID" /></td>
                        <td data-th="名稱"><b-button size="sm" variant="link" @click="edit(item.GroupID)">{{item.Name}}</b-button></td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit"></Detail>
    </page-main>
</template>

<script>
    import Detail from './groupDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'group',
        api: '/api/group/',
        components: { Detail },
    });
</script>

<style>
</style>